import React from 'react'
import Hero from './Hero'
import Articles from './Articles'
import AppAd from './AppAd'
import PopularStays from './PopularStays'
import BrowseType from './BrowseType'
//import PopularDestinations from './PopularDestinations'
//import PopularTrips from './PopularTrips'
import PopularHalls from './PopularHalls'
import { useTranslation } from 'react-i18next'
import { useSEO } from '../../custom hooks/useSEO'

const Home = () => {
      const { t: tSeo} = useTranslation("seo");
  
    const seo=useSEO({
      title: tSeo("home.title"),
      description: tSeo("home.description"),
    });
  return (
    <div className=''>
      {seo}
      <Hero />
      <PopularStays />
      <BrowseType />
      <PopularHalls />
      <Articles />
      <AppAd />
    </div>
  )
}

export default Home 